import React from 'react'

export const ToolIcon = () => (
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M9.69679 10.5756L9.03772 11.2347L2.66669 7.06055L7.0605 2.66673L11.2346 9.03776L10.5756 9.69683L17.4988 16.6201C18.7051 15.8209 20.3465 15.9527 21.4093 17.0155L25.8031 21.4093C27.0164 22.6227 27.0164 24.5898 25.8031 25.8031C24.5898 27.0165 22.6226 27.0165 21.4093 25.8031L17.0155 21.4093C15.9527 20.3465 15.8208 18.7052 16.6201 17.4989L9.69679 10.5756Z"
			fill="url(#paint0_linear_28846_34244)"
		/>
		<path
			d="M26.9905 7.59053C26.9815 7.58155 25.1619 9.38157 21.5404 12.9996L18.9995 10.4568L24.4136 5.03875C21.5644 3.32258 17.9041 3.76285 15.5307 6.13793C14.6235 7.0453 13.9706 8.17544 13.6375 9.41499C13.3045 10.6546 13.5866 12.3216 13.9167 13.5619L13.9706 13.7626L5.43436 22.3C5.2488 22.4857 5.34187 22.705 5.52743 22.8907L9.10195 26.4657C9.28751 26.6514 9.51692 26.7544 9.70248 26.5687L18.2387 18.0313L18.4393 18.0852C20.9443 18.7531 23.9856 18.3428 25.8532 16.4739C28.2296 14.0988 28.6695 10.4358 26.9905 7.59053Z"
			fill="#4A4A4A"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_28846_34244"
				x1="24.5498"
				y1="29.3831"
				x2="1.28369"
				y2="6.11693"
				gradientUnits="userSpaceOnUse">
				<stop stopColor="#5C90FC" />
				<stop offset="1" stopColor="#B7D2FF" />
			</linearGradient>
		</defs>
	</svg>
)
